module.exports = __webpack_public_path__ + "img/grin-alt.cb423086.svg";